// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IconMembers {\n  border: 1px solid;\n  border-radius: 3px;\n  text-align: center;\n  font-size: 0.7em;\n  line-height: 12px;\n  height: 12px;\n  width: 11px;\n  display: inline-block;\n  margin-right: 5px; }\n", ""]);
// Exports
module.exports = exports;
